<template>
	<div class="c-empty-state">

		<h2 class="h2">Helaas, we hebben geen zorgkantoren gevonden.</h2>
		<p class="text-body">Ga nu opnieuw opzoek naar jouw zorgkantoor!</p>

		<button
			class="c-button c-button--outline"
			@click="$emit('reset')"
    	>
			Toon alle zorgkantoren
		</button>

	</div>
</template>

<script>
export default {
	name: 'EmptyState',
};
</script>

<style lang="scss" scoped></style>
